import React from "react";
import "./WeatherForecastDay.css";
import tempConverter from './tempConverter.js';

export default function WeatherForecastDay(props) {
    
    function day(){
    let date = new Date(props.data.dt*1000);
    let day = date.getDay();

    let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    
    return days[day];
    }
    
    return (
        <div>
           <div className="WeatherForecast-day">{day()}</div>
           <div className="WeatherIconDaily"><img src={`http://openweathermap.org/img/wn/${props.data.weather[0].icon}@2x.png`} alt='icon' /></div>
           <div className="WeatherForecast-temperatures">
               <span className="WeatherForecast-temperature-max">{tempConverter(props.data.temp.max, props.unit)}</span>°
            {" "} 
               <span className="WeatherForecast-temperature-min">{tempConverter(props.data.temp.min, props.unit)}</span>°
               </div>
               </div>
    );
}